import { createRouter, createWebHistory } from 'vue-router'
import Home from './views/Home.vue'
import Login from './views/Login.vue'
import Dashboard from './views/Dashboard.vue'
import AdmConfig from './views/AdmConfig.vue'
import Users from './views/Users.vue'
import Archive from './views/Archive.vue'
import Help from './views/Help.vue'
import { useAuthStore } from './stores/auth.js'

const routes = [
  { 
    path: '/', 
    redirect: '/home/dashboard'
  },
  { 
    path: '/login', 
    name: 'login',
    component: Login,
    meta: { requiresAuth: false }
  },
  { 
    path: '/home',
    name: 'home', 
    component: Home,
    meta: { requiresAuth: true },
    redirect: '/home/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: Dashboard,
        meta: { requiresAuth: true }
      },
      {
        path: 'archive',
        name: 'archive',
        component: Archive,
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'help',
        name: 'help',
        component: Help,
        meta: { requiresAuth: true }
      },
      {
        path: 'adm-config',
        name: 'adm-config',
        component: AdmConfig,
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'users',
        name: 'users',
        component: Users,
        meta: { requiresAuth: true, requiresSuperAdmin: true }
      }
    ]
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

// Guard di navigazione globale
router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()
  
  // Se la rotta richiede autenticazione
  if (to.meta.requiresAuth) {
    // Inizializza l'autenticazione se non è già stata fatta
    if (!authStore.isAuthenticated && authStore.token) {
      await authStore.initializeAuth()
    }
    
    // Controlla se il token è scaduto
    if (authStore.token && authStore.isTokenExpired()) {
      authStore.logout()
    }
    
    // Se non è autenticato, reindirizza al login
    if (!authStore.isLoggedIn) {
      next('/login')
      return
    }

    // Controllo ruoli
    const userRole = authStore.user?.role
    if (to.meta.requiresSuperAdmin && userRole !== 'superadmin') {
      next('/home/dashboard')
      return
    }
    
    if (to.meta.requiresAdmin && userRole !== 'admin' && userRole !== 'superadmin') {
      next('/home/dashboard')
      return
    }
  }
  
  // Se é autenticado e está tentando ir para o login, redireciona para o dashboard
  if (to.path === '/login' && authStore.isLoggedIn) {
    next('/home/dashboard')
    return
  }
  
  next()
})

export default router